import { CheckOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { RefreshArrowIcon, SignatureIcon, TeamIcon } from '@mm/icons';
import { G2BadgeTop50 } from '@mm/icons/general/G2BadgeTop50';
import { MetaBadge } from '@mm/icons/general/MetaBadge';
import classNames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../../layout/BotBuilderSidebar/Logo/Logo';
import { Iconiq } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/Iconiq';
import { Inc500 } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/Inc500';
import { ProductDay } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/ProductDay';
import { ProductHunt } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/ProductHunt';
import { ProductWeek } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/ProductWeek';
import { Routes } from '../../../routes/top-level-routes';
import css from './SelfService.module.css';

export const SelfService = () => {
  const history = useHistory();

  const planPoints = [
    'X-Ray Pixel',
    'Advanced X-Ray Pixel settings',
    'Email automations',
    'Signs of life detector',
    'Suppression lists',
    'AI copywriting',
    'Contact Enrichment',
    'Restore - Ad retargeting sync',
    'Email deliverability tools',
  ];
  const prices = [
    '$0.20 Per contact captured',
    '$0.02 Per email send',
    '$0.01 Per social send',
    '$0.05 Per consumer directory lead',
  ];

  const onClick = () => {
    history.push(Routes.subscribe.getLink('enterprise_2023_introductory'), {
      showCompanySelect: true,
    });
  };

  return (
    <div className={css.wrapper}>
      <div className={css.background}>
        <div className={css.left}>
          <Logo className={css.desktopLogo} />
          <div className={css.description}>
            <div
              className={classNames(
                css.headlineContainer,
                css.leftHeadlineContainer,
              )}
            >
              <div className={css.headline}>
                <span>
                  Start capturing your website visitor info.
                  <br /> Supercharge your marketing.
                </span>
              </div>

              <ul className={css.list}>
                <li className={css.listElement}>
                  <figure>
                    <SignatureIcon />
                  </figure>
                  <span>Send AI-personalized email follow-ups</span>
                </li>

                <li className={css.listElement}>
                  <figure>
                    <TeamIcon />
                  </figure>
                  <span>Create enriched B2C and B2B visitor profiles</span>
                </li>

                <li className={css.listElement}>
                  <figure>
                    <RefreshArrowIcon />
                  </figure>
                  <span>
                    Restore ad retargeting audiences affected by Google and
                    Apple cookie and script deletion
                  </span>
                </li>
              </ul>

              <div className={css.rows}>
                <div className={css.row}>
                  <G2BadgeTop50 />
                  <Iconiq />
                  <MetaBadge className={css.badge} />
                  <Inc500 />
                </div>
                <div className={css.row}>
                  <ProductDay />
                  <ProductWeek />
                  <ProductHunt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classNames(css.right)}>
          <div
            className={classNames(
              css.headlineContainer,
              css.rightHeadlineContainer,
            )}
          >
            <div className={css.planBlock}>
              <div className={css.headline}>Try our Introductory plan</div>
              <div className={css.priceBlock}>
                <div className={css.price}>
                  <span>Starts at:</span>{' '}
                  <span className={css.priceTag}>
                    $99<span className={css.price}>/mo</span>
                  </span>
                </div>
                <Button css={{ container: css.button }} onClick={onClick}>
                  Get Started
                </Button>
              </div>
            </div>
            <div className={css.grid}>
              <span className={css.gridLabel}>What you get?</span>
              <div className={css.pointsBlock}>
                {planPoints.map(p => (
                  <span className={css.point} key={p}>
                    <CheckOutlined className={css.checkIcon} /> {p}
                  </span>
                ))}
              </div>
              <span className={classNames(css.gridLabel, css.priceLabel)}>
                Cost Per Contact
              </span>
              <div className={classNames(css.pointsBlock, css.pricePoints)}>
                {prices.map(p => (
                  <span className={css.point} key={p}>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
